import { forwardRef } from 'react';

import { cn } from '@/utils';

const Table = forwardRef(({ className, ...props }, ref) => (
	<div className="relative w-full overflow-auto">
		<table
			ref={ref}
			className={cn('w-full caption-bottom text-sm', className)}
			{...props}
		/>
	</div>
));
Table.displayName = 'Table';

const TableHeader = forwardRef(({ className, ...props }, ref) => (
	<thead
		ref={ref}
		className={cn(
			'bg-grey-100 [&_th:first-child]:rounded-l [&_th:last-child]:rounded-r [&_tr]:border-b-0',
			className
		)}
		{...props}
	/>
));
TableHeader.displayName = 'TableHeader';

const TableBody = forwardRef(({ className, ...props }, ref) => (
	<tbody ref={ref} className={cn(className)} {...props} />
));
TableBody.displayName = 'TableBody';

const TableFooter = forwardRef(({ className, ...props }, ref) => (
	<tfoot
		ref={ref}
		className={cn('border-t font-medium [&>tr]:last:border-b-0', className)}
		{...props}
	/>
));
TableFooter.displayName = 'TableFooter';

const TableRow = forwardRef(({ className, ...props }, ref) => (
	<tr
		ref={ref}
		className={cn('border-b transition-colors', className)}
		{...props}
	/>
));
TableRow.displayName = 'TableRow';

const TableHead = forwardRef(({ className, ...props }, ref) => (
	<th
		ref={ref}
		className={cn(
			'h-6 px-2 py-0.5 text-left align-middle text-xs font-semibold leading-5 text-grey-500',
			className
		)}
		{...props}
	/>
));

TableHead.displayName = 'TableHead';

const TableCell = forwardRef(({ className, children, ...props }, ref) => (
	<td
		ref={ref}
		className={cn(
			'px-2 pb-3 pt-5 align-top lg:align-middle [&:has([role=checkbox])]:pr-0',
			className
		)}
		{...props}
	>
		<div className="flex min-h-[32px] items-center">{children}</div>
	</td>
));
TableCell.displayName = 'TableCell';

const TableCaption = forwardRef(({ className, ...props }, ref) => (
	<caption ref={ref} className={cn('mt-4 text-sm', className)} {...props} />
));
TableCaption.displayName = 'TableCaption';

export {
	Table,
	TableHeader,
	TableBody,
	TableFooter,
	TableHead,
	TableRow,
	TableCell,
	TableCaption
};
